import registerFrameCallback from './frameCallback';

export default registerFrameCallback;
